import type { Priority } from "@app/core";
import { type ClaudeClient, extractText, MODELS } from "./client.js";
import { PARSE_TASK_SYSTEM } from "./prompts/parse-task.js";

export interface TaskDraft {
  title: string;
  notes: string;
  due_at: string | null;
  all_day: boolean;
  priority: Priority;
  recurrence: null | {
    freq: "daily" | "weekly" | "monthly" | "yearly";
    interval: number;
    byDay: string[] | null;
    byMonthDay: number | null;
    until: string | null;
  };
}

/**
 * Parse user text like "remind me to call mom every Tue at 6pm" into a TaskDraft.
 * The caller decides whether to confirm with the user before persisting.
 */
export async function parseNaturalLanguage(
  client: ClaudeClient,
  text: string,
  now: Date = new Date(),
): Promise<TaskDraft> {
  const res = await client.messages.create({
    model: MODELS.haiku,
    max_tokens: 512,
    system: [
      {
        type: "text",
        text: PARSE_TASK_SYSTEM,
        cache_control: { type: "ephemeral" },
      },
    ],
    messages: [
      {
        role: "user",
        content: `Current datetime: ${now.toISOString()}\nUser timezone offset minutes: ${now.getTimezoneOffset()}\n\nInput: ${text}`,
      },
    ],
  });
  return parseJson(extractText(res, { required: true }));
}

function parseJson(s: string): TaskDraft {
  const trimmed = s.trim().replace(/^```(?:json)?/i, "").replace(/```$/i, "").trim();
  return JSON.parse(trimmed) as TaskDraft;
}
